// Dependency-free PDF export via the browser's print dialog (Save as PDF).
function esc(s = "") {
  return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

function open(title, bodyHtml) {
  const w = window.open("", "_blank");
  if (!w) return;
  w.document.write(`<!doctype html><html lang="it"><head><meta charset="utf-8"><title>${esc(title)}</title>
  <style>
    * { box-sizing: border-box; }
    body { font-family: 'Segoe UI', Arial, sans-serif; color: #0f172a; max-width: 720px; margin: 40px auto; padding: 0 24px; line-height: 1.6; }
    h1 { font-size: 26px; margin-bottom: 4px; }
    .sub { color: #64748b; font-size: 13px; margin-bottom: 24px; border-bottom: 2px solid #4F46E5; padding-bottom: 12px; }
    h3 { font-size: 16px; margin: 20px 0 6px; }
    .q { margin: 16px 0; padding: 14px 16px; border: 1px solid #e2e8f0; border-radius: 10px; page-break-inside: avoid; }
    .opt { margin: 4px 0 4px 12px; }
    .correct { color: #059669; font-weight: 700; }
    .expl { color: #64748b; font-size: 13px; margin-top: 8px; }
    .body { white-space: pre-wrap; }
    @media print { body { margin: 0 auto; } }
  </style></head><body>${bodyHtml}</body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 350);
}

export function exportSummaryPdf(title, formatLabel, text) {
  const body = esc(text).replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  open(`Riassunto - ${title}`, `
    <h1>${esc(title)}</h1>
    <div class="sub">Riassunto (${esc(formatLabel)}) - StudioAI</div>
    <div class="body">${body}</div>`);
}

export function exportQuizPdf(title, questions) {
  const qs = questions.map((q, i) => `
    <div class="q">
      <h3>${i + 1}. ${esc(q.question)}</h3>
      ${q.options.map((o, j) => `<div class="opt ${j === q.correct_index ? "correct" : ""}">${String.fromCharCode(65 + j)}. ${esc(o)}${j === q.correct_index ? " &#10003;" : ""}</div>`).join("")}
      ${q.explanation ? `<div class="expl"><strong>Spiegazione:</strong> ${esc(q.explanation)}</div>` : ""}
    </div>`).join("");
  open(`Quiz - ${title}`, `
    <h1>${esc(title)}</h1>
    <div class="sub">Quiz (${questions.length} domande) - StudioAI</div>
    ${qs}`);
}

export function exportFlashcardsPdf(title, cards) {
  const rows = cards.map((c, i) => `
    <div class="q">
      <div style="font-weight:700;margin-bottom:6px;">${i + 1}. ${esc(c.front)}</div>
      <div style="color:#334155;">${esc(c.back)}</div>
    </div>`).join("");
  open(`Flashcard - ${title}`, `
    <h1>${esc(title)}</h1>
    <div class="sub">Flashcard (${cards.length}) - StudioAI</div>
    ${rows}`);
}
